import "../styles/MessageItem.css";
import { PersonFill, CpuFill } from "react-bootstrap-icons"; // AI için CpuFill ikonu
import { useContext } from "react";
import { ThemeContext } from "../contexts/ThemeContext";

const MessageItem = ({ message, isSentByUser }) => {
  const { isDarkMode } = useContext(ThemeContext); // ThemeContext kullanımı

  return (
    <>
      <div className={`message-row ${isSentByUser ? "user-row" : "bot-row"} ${isDarkMode ? "dark-mode" : ""}`}>
        <div className={`message-item ${isSentByUser ? "user-message" : "bot-message"} ${isDarkMode ? "dark-mode" : ""}`}>
          <div className="message-meta">
            {isSentByUser ? (
              <PersonFill className={`icon user-icon ${isDarkMode ? "dark-mode" : ""}`} />
            ) : (
              <CpuFill className={`icon bot-icon ${isDarkMode ? "dark-mode" : ""}`} />
            )}
          </div>
          <div className="message-content">{message}</div>
        </div>
      </div>
      <hr className={`message-divider ${isDarkMode ? "dark-mode" : ""}`} />
    </>
  );
};

export default MessageItem;